import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  Box,
  Divider,
  IconButton,
  Paper,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadableAttachment from '../../../utils/common/DownloadableAttachment';
import NoteIcon from '../../../utils/common/NoteIcon';
import TypographyWithHighlightMentions from '../../../utils/common/TypographyWithHighlightMentions';

export const TicketActivityNote = ({ note, ticket }) => {
  const _theme = useTheme();
  const navigate = useNavigate();

  const handleNavigateToTask = () => {
    if (note?.task?._id) {
      navigate(
        `/project/${ticket?.project?._id}/tickets/${ticket?._id}/tasks/${note?.task?._id}`
      );
    }
  };

  return (
    <Paper
      elevation={16}
      key={note?._id}
      sx={{
        padding: 1,
        marginBottom: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <NoteIcon boxSize={32} iconSize={24} />
        <Typography component="span">
          {`${note?.user?.firstName} ${note?.user?.lastName}`}
        </Typography>
        <Typography component="span">
          {note?.type?.name}
          {note?.task?._id ? ` (${note?.task?.action?.name})` : ''}
        </Typography>
        <Typography component="span" variant="caption">
          {new Date(note?.date).toLocaleString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
          })}
        </Typography>
        {note?.task?._id && (
          <IconButton onClick={handleNavigateToTask} color="primary">
            <ArrowForwardIcon />
          </IconButton>
        )}
      </Box>
      <Divider />
      <Box>
        <TypographyWithHighlightMentions text={note?.content} />
      </Box>
      {note?.attachments?.length > 0 && (
        <>
          <Divider />
          {note?.attachments?.map((attachment) => (
            <DownloadableAttachment
              key={attachment?._id}
              attachment={attachment}
            />
          ))}
        </>
      )}
    </Paper>
  );
};

export default TicketActivityNote;
